<template>
  <div class="styleCard">
    <ul class="style-nav style2">
      <li
        v-for="tab in msgStatsTabs"
        :key="tab.id"
        :class="{ active: selectedMsgStatsTab === tab.alias }"
        @click="selectedMsgStatsTab = tab.alias"
      >
        {{ tab.name }}
      </li>
    </ul>

    <div
      id="accordion"
      v-if="
        selectedMsgStatsTab === 'DEP' && filterByMsgType('CONGRATS').length > 0
      "
    >
      <div>
        <table class="table">
          <tbody>
            <tr>
              <td class="td-users-ms">
                <div class="floating-wrapper">
                  <!--                  <users-multi-select-->
                  <!--                    :options="salesPersonList"-->
                  <!--                    :reset-list="resetMultiSelects"-->
                  <!--                    @reset="resetUsersSelector"-->
                  <!--                    :other-filtering="true"-->
                  <!--                    :initiated-filtering="resetMsAfterFilter"-->
                  <!--                    :query-object="getQueryParamsToMs"-->
                  <!--                  ></users-multi-select>-->
                </div>
              </td>
              <td><strong></strong></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="card"
        v-for="(msg, idx) in filterByMsgType('CONGRATS')
          .slice()
          .reverse()"
        :key="idx"
      >
        <div class="card-header" id="headingTwo">
          <h5 class="mb-0">
            <button
              class="btn btn-link collapsed"
              data-toggle="collapse"
              :data-target="'#' + idx"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              {{ findUserNameByID(msg.crm_user_id) }} | {{ msg.message }} |
              {{ formatDate(msg.createdAt) }}
            </button>
          </h5>
        </div>
        <div
          :id="idx"
          class="collapse"
          aria-labelledby="headingTwo"
          data-parent="#accordion"
        >
          <div class="card-body">
            <div
              class="table-responsive"
              v-if="findAssociatedNotes(msg._id).length > 0"
            >
              <table class="table">
                <tbody>
                  <tr>
                    <td>
                      <strong>{{ msg.message }}</strong>
                    </td>
                    <td><strong>Approved</strong></td>
                    <td><strong>Declined</strong></td>
                    <td><strong>Not Responded</strong></td>
                    <td><strong>Time</strong></td>
                  </tr>

                  <tr
                    v-for="(msg, idx) in findAssociatedNotes(msg._id)"
                    :key="idx"
                  >
                    <td>{{ findUserNameByID(msg.crm_user_id) }}</td>
                    <td>
                      <span v-if="msg.approved === 'APPROVED'"
                        ><img width="21" src="/img/icons/correct.svg"
                      /></span>
                    </td>
                    <td>
                      <span v-if="msg.approved === 'DECLINED'"
                        ><img width="21" src="/img/icons/correct.svg"
                      /></span>
                    </td>
                    <td>
                      <span v-if="msg.ignored === true"
                        ><img width="21" src="/img/icons/correct.svg"
                      /></span>
                    </td>
                    <td>{{ formatDate(msg.createdAt) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="accordion2"
      v-if="
        selectedMsgStatsTab === 'TASK' &&
          filterByMsgType('TASK_MISSED').length > 0
      "
    >
      <div
        class="card"
        v-for="(msg, idx) in filterByMsgType('TASK_MISSED')
          .slice()
          .reverse()"
        :key="idx"
      >
        <div class="card-header" id="headingTwo2">
          <h5 class="mb-0">
            <button
              class="btn btn-link collapsed"
              data-toggle="collapse"
              :data-target="'#' + idx"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              {{ findUserNameByID(msg.crm_user_id) }} | {{ msg.message }} |
              {{ formatDate(msg.createdAt) }}
            </button>
          </h5>
        </div>
        <div
          :id="idx"
          class="collapse"
          aria-labelledby="headingTwo"
          data-parent="#accordion"
        >
          <div class="card-body">
            <div
              class="table-responsive"
              v-if="findAssociatedNotes(msg._id).length > 0"
            >
              <table class="table">
                <tbody>
                  <tr>
                    <td>
                      <strong>{{ msg.message }}</strong>
                    </td>
                    <td><strong>Approved</strong></td>
                    <td><strong>Declined</strong></td>
                    <td><strong>Not Responded</strong></td>
                    <td><strong>Time</strong></td>
                  </tr>

                  <tr
                    v-for="(msg, idx) in findAssociatedNotes(msg._id)"
                    :key="idx"
                  >
                    <td>{{ findUserNameByID(msg.crm_user_id) }}</td>
                    <td>
                      <span v-if="msg.approved === 'APPROVED'"
                        ><img width="21" src="/img/icons/correct.svg"
                      /></span>
                    </td>
                    <td>
                      <span v-if="msg.approved === 'DECLINED'"
                        ><img width="21" src="/img/icons/correct.svg"
                      /></span>
                    </td>
                    <td>
                      <span v-if="msg.ignored === true"
                        ><img width="21" src="/img/icons/correct.svg"
                      /></span>
                    </td>
                    <td>{{ formatDate(msg.createdAt) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="accordion3"
      v-if="
        selectedMsgStatsTab === 'ANNC' && filterByMsgType('ANNC').length > 0
      "
    >
      <div
        class="card"
        v-for="(msg, idx) in filterByMsgType('ANNC')
          .slice()
          .reverse()"
        :key="idx"
      >
        <div class="card-header" id="headingTwo3">
          <h5 class="mb-0">
            <button
              class="btn btn-link collapsed"
              data-toggle="collapse"
              :data-target="'#' + idx"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              {{ findUserNameByID(msg.crm_user_id) }} | {{ msg.message }} |
              {{ formatDate(msg.createdAt) }}
            </button>
          </h5>
        </div>
        <div
          :id="idx"
          class="collapse"
          aria-labelledby="headingTwo"
          data-parent="#accordion"
        >
          <div class="card-body">
            <div
              class="table-responsive"
              v-if="findAssociatedNotes(msg._id).length > 0"
            >
              <table class="table">
                <tbody>
                  <tr>
                    <td>
                      <strong>{{ msg.message }}</strong>
                    </td>
                    <td><strong>Approved</strong></td>
                    <td><strong>Declined</strong></td>
                    <td><strong>Not Responded</strong></td>
                    <td><strong>Time</strong></td>
                  </tr>

                  <tr
                    v-for="(msg, idx) in findAssociatedNotes(msg._id)"
                    :key="idx"
                  >
                    <td>{{ findUserNameByID(msg.crm_user_id) }}</td>
                    <td>
                      <span v-if="msg.approved === 'APPROVED'"
                        ><img width="21" src="/img/icons/correct.svg"
                      /></span>
                    </td>
                    <td>
                      <span v-if="msg.approved === 'DECLINED'"
                        ><img width="21" src="/img/icons/correct.svg"
                      /></span>
                    </td>
                    <td>
                      <span v-if="msg.ignored === true"
                        ><img width="21" src="/img/icons/correct.svg"
                      /></span>
                    </td>
                    <td>{{ formatDate(msg.createdAt) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="accordion4"
      v-if="
        selectedMsgStatsTab === 'CA' && filterByMsgType('CA_MISSED').length > 0
      "
    >
      <div
        class="card"
        v-for="(msg, idx) in filterByMsgType('CA_MISSED')
          .slice()
          .reverse()"
        :key="idx"
      >
        <div class="card-header" id="headingTwo4">
          <h5 class="mb-0">
            <button
              class="btn btn-link collapsed"
              data-toggle="collapse"
              :data-target="'#' + idx"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              {{ findUserNameByID(msg.crm_user_id) }} | {{ msg.message }} |
              {{ formatDate(msg.createdAt) }}
            </button>
          </h5>
        </div>
        <div
          :id="idx"
          class="collapse"
          aria-labelledby="headingTwo"
          data-parent="#accordion"
        >
          <div class="card-body">
            <div
              class="table-responsive"
              v-if="findAssociatedNotes(msg._id).length > 0"
            >
              <table class="table">
                <tbody>
                  <tr>
                    <td>
                      <strong>{{ msg.message }}</strong>
                    </td>
                    <td><strong>Approved</strong></td>
                    <td><strong>Declined</strong></td>
                    <td><strong>Not Responded</strong></td>
                    <td><strong>Time</strong></td>
                  </tr>

                  <tr
                    v-for="(msg, idx) in findAssociatedNotes(msg._id)"
                    :key="idx"
                  >
                    <td>{{ findUserNameByID(msg.crm_user_id) }}</td>
                    <td>
                      <span v-if="msg.approved === 'APPROVED'"
                        ><img width="21" src="/img/icons/correct.svg"
                      /></span>
                    </td>
                    <td>
                      <span v-if="msg.approved === 'DECLINED'"
                        ><img width="21" src="/img/icons/correct.svg"
                      /></span>
                    </td>
                    <td>
                      <span v-if="msg.ignored === true"
                        ><img width="21" src="/img/icons/correct.svg"
                      /></span>
                    </td>
                    <td>{{ formatDate(msg.createdAt) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";

import { mapGetters, mapState } from "vuex";
import { Globals } from "../../../global_constants/constants";
//import UsersMultiSelect from "../components/multiselects/UserMultiSelect.component";

export default {
  name: "VikiMsgStats.container",
  components: {
    //  UsersMultiSelect
  },

  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("main", ["showVikiMsg", "updateDepCharts"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "transferConfirmAnswer"
    ]),
    ...mapState("main", ["showVikiMsg"])
  },

  data() {
    return {
      messages: [],
      notifyMessages: [],
      selectedMsgStatsTab: "DAILY",
      msgStatsTabs: [
        {
          id: 1,
          name: "Deposits",
          alias: "DEP"
        },
        {
          id: 2,
          name: "Announcements",
          alias: "ANNC"
        },
        {
          id: 3,
          name: "Tasks",
          alias: "TASK"
        },
        {
          id: 4,
          name: "Scheduled Calls",
          alias: "CA"
        }
      ]
    };
  },
  created() {
    this.getMessagesStatistics();
  },
  methods: {
    async getMessagesStatistics() {
      const response = await axios.get(
        Globals.viki_server_addr + "stats/messages"
      );
      this.messages = response.data;

      await this.getNotificationsStatistics();
    },

    async getNotificationsStatistics() {
      const response = await axios.get(
        Globals.viki_server_addr + "stats/notifications"
      );
      this.messages = response.data;
    },

    findAssociatedNotes(msgId) {
      return this.notifyMessages.filter(note => note.msg_id === msgId);
    },
    filterByMsgType(msgType) {
      return this.messages.filter(msg => msg.type === msgType);
    },
    findUserNameByID(userId) {
      const user = this.salesPersonList.find(item => item.id === userId);
      if (user === undefined) {
        return null;
      }
      return user.full_name;
    },
    formatDate(date) {
      return moment(String(date)).format("HH:mm DD/MM/YY");
    }
  }
};
</script>

<style scoped>
.root {
  width: 90%;
  margin: auto;
}
.card-body {
  padding: 10px;
}
.card-header {
  border-bottom: 1px solid rgba(10, 10, 10, 0.1);
}
.td-users-ms {
  width: 100px;
}
.floating-wrapper {
  position: relative;
}
.w50 {
  width: calc(50% - 0.2rem);
}
.left {
  float: left;
}
.margin {
  margin: 0.5rem;
}
.margin_r_hf {
  margin-right: 0.2rem;
}
.margin_l_c {
  margin-left: 0;
}

.styleCard {
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  overflow: hidden;
  height: 90%;
  min-width: 300px;
  position: absolute;
  margin: auto;
  top: 90px;
  right: 0;
  left: 0;
  width: 80%;
}

.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  /*
    background: white;
  */
}
.style-nav.style2 li {
  border-radius: 5px 5px 0px 0px;
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  min-width: 72px;
  height: 30px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.styleCardContent {
  background: white;
  min-height: 12rem;
  height: 100%;
}
.padding {
  padding: 1rem;
}
.form-body {
  padding: 20px;
  background-color: white;
}
.form-body form {
  margin-bottom: 20px;
}
.bttn {
  font-family: Montserrat;
  width: max-content;
  margin-top: 0.5rem;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  cursor: pointer;
  margin-left: 0.5rem;
}
.bttn-blue {
  background-color: #44a2d2;
}
.bttn-red {
  background-color: #dc3545;
}
.bttn-green {
  background-color: #28a745;
}
</style>
